import { __rest } from "tslib";
import { useContext, useEffect, useState } from 'react';
import { PulseContext } from "./pulse-react.context.js";
/**
 * Segment identifiers are internal part of the platform and
 * it's strongly recommended to configure and use settings
 * values instead of directly using segment identifiers.
 *
 */
const useLazyPulseSegments = () => {
    const { settings } = useContext(PulseContext);
    const [segmentsData, setSegmentsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState();
    if (!settings) {
        throw new Error('Cannot use "segments" hook, please add "settings" to sdks array when initializing the Provider');
    }
    return {
        loading,
        segments: segmentsData,
        hasError,
        error,
        get: () => {
            setLoading(true);
            settings
                .getSegments()
                .then((result) => {
                setSegmentsData(result);
                setLoading(false);
            })
                .catch((err) => {
                setHasError(true);
                setError(err);
            });
        }
    };
};
/**
 * Segment identifiers are internal part of the platform and
 * it's strongly recommended to configure and use settings
 * values instead of directly using segment identifiers.
 *
 */
const usePulseSegments = () => {
    const _a = useLazyPulseSegments(), { get } = _a, rest = __rest(_a, ["get"]);
    useEffect(() => {
        get();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return Object.assign({}, rest);
};
export { useLazyPulseSegments, usePulseSegments };
//# sourceMappingURL=use-pulse-segments.hook.js.map